import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Button,
  Tooltip,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { localStorageFunc, notify } from "../../../../helpers/utility";
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import { IconButton, InputAdornment } from '@mui/material';
import { connect } from "react-redux";
import * as actions from "../../../../store/actions/actionIndex";
import CallerId from "../../../../components/Modal/CallerId";

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      //   width: 200,
    },
  },
  grid: {
    padding: "0 10px 0 0px !important",
  },
  label: {
    padding: "0",
    width: "100%",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0.5px",
    color: "#686D88",
  },
  textfield: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "22px",
    color: "#343A58",
    // border: "1px solid #686D88",
    boxSizing: "border-box",
    borderRadius: "4px",
    margin: "8px 0 !important",
  },
  CancelButton: {
    margin: "5px",
    backgroundColor: "white",
    border: "1px solid blue",
    textTransform: "capitalize",
  },
  UpdateButton: {
    height: "41px",
    margin: "5px",
    textTransform: "capitalize",
  },
  Buttons: {
    display: "flex",
    flexDirection: "row reverse ",
    flex: "1",
    justifyContent: "flex-end",
  },
}));

function EditCustomerDetails(props) {
  const classes = useStyles();
  const crmValues = props.crmValues;
  const [dialNumber, setDialNumber] = useState("")
  const [phoneType, setPhoneType] = useState("")
  const [showModal, setShowModal] = useState(false)
  const [callerIdFromModal, setCallerIdFromModal] = useState('');
  const [callerFlag, setCallerFlag] = useState(localStorageFunc.get("callerFlag"));
  const [callDial, setCallDial] = useState(false);
  const [disconnectCheck, setDisconnectCheck] = useState(false)

  const [abc, setAbc] = useState({});
  useEffect(() => {
    try {
      const storedData = localStorageFunc.get("crmValues");
      setAbc(storedData ? JSON.parse(storedData) : {});
    } catch (error) {
      console.error("Error parsing localStorage data:", error);
      setAbc({});
    }
  }, [crmValues]);



  // MultiLevel CRM feilds from External files
  
  const handleUpdate = () => {
    props.handleUpdate();
  };
 const handleModalClose = ()=>{
setShowModal(false)
  }
const handleCallerIdSelect = (selectedCallerId) => {
  const callerIdToUse = selectedCallerId || "";
  setCallerIdFromModal(callerIdToUse);
  setShowModal(false);
  props.onDisconnectIconClick();

  // ✅ Send request to parent
  props.onRequestAgentDial({
    dialNumber,
    phoneType,
    leadId: props.leadId,
    callerId: callerIdToUse,
  });
};



   const disposeDial = (event, fieldName) => {
  event.preventDefault();
  try {
    const getPhoneValue = localStorageFunc.get("crmValues");
    const parsedValues = getPhoneValue ? JSON.parse(getPhoneValue) : {};

    const phoneNumber = parsedValues[fieldName] || abc[fieldName] || crmValues[fieldName] || '';
    setDialNumber(phoneNumber);

    const match = fieldName.match(/phone(\d+)$/);
    const phoneSuffix = match ? match[1] : '';
    const phoneTypeValue = `10${phoneSuffix}`;
    setPhoneType(phoneTypeValue);

    // Don't open modal here directly
  } catch (error) {
    console.error("Failed to get or parse crmValues from localStorage", error);
  }
};

useEffect(() => {
  if (!dialNumber) return;
  if (callerFlag === "1") {
    setShowModal(true);
  } else {
    props.onDisconnectIconClick();
    setCallDial(true)

  }
}, [dialNumber, callerFlag]);

// useEffect(() =>{
//   setDisconnectCheck(props.disconnectStatus)
// },[props.disconnectStatus])

useEffect(() => {
  if (!dialNumber) return;

  if (callerFlag === "1") {
    setShowModal(true);
  } else {
    props.onDisconnectIconClick();
   
    props.onRequestAgentDial({
      dialNumber,
      phoneType,
      leadId: props.leadId,
      callerId: callerIdFromModal,
    });
  }
}, [dialNumber, callerFlag]);


  return (
    <>
     {showModal && (
    <CallerId isOpen={showModal}
    onClose={handleModalClose}
    onCallerIdSelect={handleCallerIdSelect}    phoneNumber = {dialNumber}/>
        )}
      
    <form className={classes.root} noValidate autoComplete="off">
      <Grid className="edit-table" container spacing={1}>
        {props.group.length &&
          props.group.map((arrItem, index) => {
            if (arrItem.type === "select") {
              return (
                <Grid
                  container
                  className={classes.grid}
                  key={arrItem.name}
                  item
                  md={4}
                  xs={12}
                  lg={4}
                >
                  {/* <label className={classes.label}>{arrItem.label}</label> */}
                  <label className={classes.label}>
                  {arrItem.label}
                  {arrItem.mandatory && (
                    <span className="mandatory-point" style={{ color: "red" }}>
                      *
                    </span>
                  )}
                </label>
                  <TextField
                    className={classes.textfield}
                    fullWidth
                    margin="dense"
                    id = {arrItem.name}
                    name={arrItem.name}
                    onChange={props.handleCrmChange}
                    required={arrItem.mandatory === true}
                    select
                    SelectProps={{ native: true }}
                    value={
                      arrItem.isWritable === false
                        ? crmValues[arrItem.name] !== ""
                          ? crmValues[arrItem.name]
                          : "N/A"
                        : abc[arrItem.name] || crmValues[arrItem.name] || ""
                    }
                    variant="outlined"
                    disabled={arrItem.isWritable === false}
                  >
                    {/* {(() => {
                      const name = arrItem.name;

                      if (name.includes("sub")) {
                        const underscoreCount = (name.match(/_/g) || []).length;

                        if (underscoreCount === 1) {
                          return subDispositionOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ));
                        } else if (underscoreCount === 2) {
                          return subSubDispositionOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ));
                        }
                      }
                      return arrItem.options.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ));
                    })()} */}
                    {Object.entries(arrItem.options).map(
                                            ([key, value]) => (
                                                <option key={key} value={value}>
                                                    {value}
                                                </option>
                                            )
                                        )}

                  </TextField>
                </Grid>
              );
            }
            if (arrItem.type === "checkbox") {
              return (
                <FormControlLabel
                  key={index}
                  control={
                    <GreenCheckbox
                      checked={crmValues.checked}
                      onChange={(event) => props.handleChange(event)}
                      value={abc[arrItem.name] || crmValues[arrItem.name] || ""}
                    />
                  }
                  label={arrItem.label}
                  disabled={arrItem.isWritable === false ? true : false}
                />
              );
            }
            return (
              <Grid
                container
                className={classes.grid}
                key={index}
                item
                md={4}
                xs={12}
                lg={4}
              >
                <label className={classes.label}>
                  {arrItem.label}
                  {arrItem.mandatory && (
                    <span className="mandatory-point" style={{ color: "red" }}>
                      *
                    </span>
                  )}
                </label>
                <TextField
                  fullWidth
                  className={classes.textfield}
                  margin="dense"
                  type={arrItem.type}
                  name={arrItem.name}
                  id = {arrItem.name}
                  onChange={(event) => props.handleCrmChange(event)}
                  required={arrItem.mandatory === true}
                  value={
                    arrItem.isWritable === false
                      ? crmValues[arrItem.name] !== ""
                        ? crmValues[arrItem.name]
                        : "N/A"
                      :  abc[arrItem.name] || crmValues[arrItem.name]
                  }
                  variant="outlined"
                  disabled={arrItem.isWritable === false ? true : false}
                  InputProps={{
                    endAdornment:
                      /^Phone[1-9]$/.test(arrItem.label) && arrItem.isWritable !== false && (props.agentState === 'CLOSURE' || props.agentState === "PREVIEW_FAIL") &&
                      (abc[arrItem.name] || crmValues[arrItem.name] || "").trim() !== "" ? (
                        <InputAdornment position="end">
                          <Tooltip title="Dispose & Dial" arrow>
                            <IconButton
                              onClick={(event) => disposeDial(event, arrItem.name)}
                              size="small"
                              
                            >
                              <PhoneCallbackIcon fontSize="small" style={{ color: "rgb(12, 130, 218)" }}/>
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ) : null,
                  }}
                />
              </Grid>
            );
          })}
      </Grid>

      {/* <Grid className={classes.Buttons} container spacing={1}>
        <Button
          id="btnUpdate"
          className={classes.UpdateButton}
          variant="contained"
          color="primary"
          onClick={handleUpdate}
        >
          {props.loading ? (
            <CircularProgress size={18} style={{ verticalAlign: "middle" }} />
          ) : (
            ""
          )}
          Update
        </Button>
      </Grid> */}
    </form>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    error: state.agentDial.error,
    loading: state.agentDial.loading,
    agentState: state.agentData.agentState,
    agentId: state.agentData.agentId,
    campConf: state.agentConfig.campConf,
     disconnectStatus: state.agentDisconnect.dispStatus,
    leadId: state.agentData.leadId,
    crmPhoneValues: state.customerDetails.crmValues,                 
    
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAgentDial: (agentId, phone, leadId, listId, callerId, redial, phoneType) =>
      dispatch(actions.agentDial(agentId, phone, leadId, listId, callerId, redial, phoneType)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditCustomerDetails);
